import { createFileRoute } from '@tanstack/react-router'
import { DepartmentEditor } from './-DepartmentEditor'

// ModuleGuard is provided by the departments route.tsx layout.
export const Route = createFileRoute('/hr/departments/$id')({
  component: DepartmentDetailPage,
})

function DepartmentDetailPage() {
  const { id } = Route.useParams()
  return <DepartmentEditor id={id} />
}
